module.exports = __webpack_public_path__ + "03_short_black.c5d2fdab.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/mama/layer5/03_short_black.png
// module id = UH1H
// module chunks = 0